/**
 * Access to the New Relic Browser agent from code outside index.js.
 *
 * The agent only exists when New Relic is configured and enabled, so every helper
 * here is a no-op otherwise (local dev, missing licence key). They also swallow
 * their own errors: telemetry must never be able to break a page, least of all an
 * unattended kiosk.
 */
import { BUILT_AT, GIT_COMMIT } from '../buildInfo'

let agent = null

const getAgentApi = () => agent || (typeof window === 'undefined' ? null : window.newrelic)

export const setGlobalAttribute = (name, value) => {
  const api = getAgentApi()
  if (!api || typeof api.setCustomAttribute !== 'function') return

  try {
    api.setCustomAttribute(name, value)
  } catch (error) {
    // Best-effort by design.
  }
}

export const registerNewRelicAgent = instance => {
  agent = instance
  // Attached globally rather than per event so they also ride along on JS errors,
  // which is how we tell which commit a reporting kiosk is actually running and how
  // long it has been since that bundle was built.
  if (GIT_COMMIT) setGlobalAttribute('gitCommit', GIT_COMMIT)
  if (BUILT_AT) setGlobalAttribute('builtAt', BUILT_AT)
}

export const recordPageAction = (name, attributes = {}) => {
  const api = getAgentApi()
  if (!api || typeof api.addPageAction !== 'function') return

  try {
    api.addPageAction(name, attributes)
  } catch (error) {
    // See setGlobalAttribute.
  }
}

export const noticeError = (error, attributes = {}) => {
  const api = getAgentApi()
  if (!api || typeof api.noticeError !== 'function') return

  try {
    api.noticeError(error, attributes)
  } catch (e) {
    // See setGlobalAttribute.
  }
}
